"use client";

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "next-intl";
import { Icon, Typography } from "@/shared/ui/atoms";
import { CustomButton } from "@/shared/ui/molecules";
import type { FilterValue, Region } from "@/shared/types/type/search";
interface RankingUnsupportedNoticeProps {
  regionList: Region[];
  treatmentList: FilterValue[];
  supportedRegionIds: Set<number>;
  supportedTreatmentIds: Set<number>;
  selectedRegionCategoryId: number;
  selectedTreatmentCategoryId: number;
  isUnsupportedRegion: boolean;
  isUnsupportedTreatment: boolean;
  onSelect: (regionCategoryId: number, treatmentCategoryId: number) => void;
}
const SUGGESTION_LIMIT = 3;

/**
 * 랭킹이 없는 조합에서 쓰는 안내(B2C-476).
 *
 * 검색 전용 빈 화면("검색어를 변경해보세요")을 쓰면, 검색어 입력란도 없는 화면에서
 * 검색어를 고치라고 안내하게 된다. 사용자는 일시적 문제인지 원래 없는 건지 알 수 없다.
 * 무엇이 없는지 밝히고 갈 수 있는 곳을 같이 준다.
 */
const RankingUnsupportedNotice = t0 => {
  const $ = _c(16);
  const {
    regionList,
    treatmentList,
    supportedRegionIds,
    supportedTreatmentIds,
    selectedRegionCategoryId,
    selectedTreatmentCategoryId,
    isUnsupportedRegion,
    isUnsupportedTreatment,
    onSelect
  } = t0;
  const t = useTranslations();
  const findName = _temp;
  let t1;
  if ($[0] !== isUnsupportedRegion || $[1] !== isUnsupportedTreatment || $[2] !== onSelect || $[3] !== regionList || $[4] !== selectedRegionCategoryId || $[5] !== selectedTreatmentCategoryId || $[6] !== supportedRegionIds || $[7] !== supportedTreatmentIds || $[8] !== t || $[9] !== treatmentList) {
    const flatRegions = regionList.flatMap(_temp2);
    let t2;
    if ($[11] !== supportedTreatmentIds) {
      t2 = item_0 => supportedTreatmentIds.has(item_0.id);
      $[11] = supportedTreatmentIds;
      $[12] = t2;
    } else {
      t2 = $[12];
    }
    const supportedTreatments = treatmentList.filter(t2);
    let t3;
    if ($[13] !== supportedRegionIds) {
      t3 = item_1 => supportedRegionIds.has(item_1.id);
      $[13] = supportedRegionIds;
      $[14] = t3;
    } else {
      t3 = $[14];
    }
    const supportedRegions = flatRegions.filter(t3);
    const missingLabel = isUnsupportedTreatment ? findName(treatmentList, selectedTreatmentCategoryId) : findName(flatRegions, selectedRegionCategoryId);
    const suggestions = isUnsupportedTreatment && !isUnsupportedRegion ? supportedTreatments.map(treatment => ({
      key: `t-${treatment.id}`,
      label: treatment.name,
      regionCategoryId: selectedRegionCategoryId,
      treatmentCategoryId: treatment.id
    })) : supportedRegions.slice(0, SUGGESTION_LIMIT).map(region_0 => ({
      key: `r-${region_0.id}`,
      label: region_0.name,
      regionCategoryId: region_0.id,
      treatmentCategoryId: supportedTreatmentIds.has(selectedTreatmentCategoryId) ? selectedTreatmentCategoryId : supportedTreatments[0]?.id ?? selectedTreatmentCategoryId
    }));
    let t4;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <Icon src="/icons/no-search.svg" alt="" width={56} height={56} />;
      $[15] = t4;
    } else {
      t4 = $[15];
    }
    t1 = <div className="flex flex-1 flex-col items-center justify-center gap-3 rounded-xl bg-white px-6 py-16 text-center">{t4}<Typography size={16} lineHeight={22} className="font-semibold text-gray-900">{missingLabel ? t("unsupported.title", {
          name: missingLabel
        }) : t("unsupported.titleFallback")}</Typography>{supportedTreatments.length > 0 && <Typography size={14} lineHeight={20} className="text-gray-500">{t("unsupported.description", {
          treatments: supportedTreatments.map(_temp3).join(" \xB7 ")
        })}</Typography>}{suggestions.length > 0 && <div className="mt-2 flex flex-wrap items-center justify-center gap-2">{suggestions.map(suggestion => <CustomButton key={suggestion.key} className="rounded-full border border-primary-200 bg-primary-50 px-4 py-2" onClick={() => onSelect(suggestion.regionCategoryId, suggestion.treatmentCategoryId)}><Typography as="span" size={14} lineHeight={18} className="font-semibold text-primary-600">{t("unsupported.goTo", {
              name: suggestion.label
            })}</Typography></CustomButton>)}</div>}</div>;
    $[0] = isUnsupportedRegion;
    $[1] = isUnsupportedTreatment;
    $[2] = onSelect;
    $[3] = regionList;
    $[4] = selectedRegionCategoryId;
    $[5] = selectedTreatmentCategoryId;
    $[6] = supportedRegionIds;
    $[7] = supportedTreatmentIds;
    $[8] = t;
    $[9] = treatmentList;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  return t1;
};
export default RankingUnsupportedNotice;
function _temp(list, id) {
  return list.find(item => item.id === id)?.name ?? "";
}
function _temp2(region) {
  return [region, ...(region.children ?? [])];
}
function _temp3(item_2) {
  return item_2.name;
}